module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('app-slider'), _vm._v(" "), _c('app-navigation'), _vm._v(" "), _c('app-random-archives')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34cd6ba9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 83
// module chunks = 0